module.exports = __webpack_public_path__ + "img/home-middle.ad5c59bb.png";